import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=4eafb187&scoped=true&"
import script from "./dashboard.ts?vue&type=script&lang=ts&"
export * from "./dashboard.ts?vue&type=script&lang=ts&"
import style0 from "./dashboard.scss?vue&type=style&index=0&id=4eafb187&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eafb187",
  null
  
)

export default component.exports